export default [
  {
    path: '/active-sessions',
    name: 'active-sessions',
    component: () => import('@/views/active-sessions/ActiveSessions.vue'),
    meta: {
      title: 'Active Sessions',
      requiresAuth: true,
    },
  },
]
